import * as React from 'react'
import { Link } from 'react-router-dom'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import { getFullDisplayName } from 'modules/core/lib/userDisplayName'

import type { CalendarEmployeeLookup } from 'modules/calendar/lib/calendarEmployeeData'
import { calendarEventCanSeeTimeoffTypes } from 'modules/calendar/lib/calendarLeaves'
import type { CalendarViewEvent } from 'modules/calendar/lib/munchers/types'

import type LeaveStore from './LeaveStore'
import Row from './Row'

interface Props {
  event: CalendarViewEvent
  leaveStore: LeaveStore
  employeeLookup: CalendarEmployeeLookup
}

const MonthEvent = (props: Props) => {
  const { navigation } = useNavigation()

  const {
    leaveStore,
    employeeLookup,
    event: { model },
  } = props

  const employeeId = model.metadata('employee_id')
  const employee = employeeLookup.get(employeeId)

  const getTitle = () => {
    if (!employee) return '–'
    return getFullDisplayName({
      firstName: employee.firstName,
      lastName: employee.lastName,
      canSharePreferredName: employee._policies?.sharePreferredName.can ?? false,
      preferredName: employee.preferredName,
    })
  }
  const title = getTitle()

  const leaveId = model.metadata('leave_id')
  const url = navigation.calendar.leaves.editLeave.fullPath({ leave_id: leaveId })

  const canReadLeaves = employee?._policies?.readLeaves.can ?? false

  const onMouseEnterHandler = () => {
    leaveStore.hoveredLeaveId = model.metadata('leave_id')
  }

  const onMouseLeaveHandler = () => {
    leaveStore.hoveredLeaveId = null
  }

  const isLeaveTypeVisible = calendarEventCanSeeTimeoffTypes(model, employeeLookup)

  const row = (
    <Row
      calendarEvent={model}
      colored={canReadLeaves}
      visible={isLeaveTypeVisible}
      leaveStore={leaveStore}
      title={title}
    />
  )

  const commonAttr = {
    onMouseEnter: () => onMouseEnterHandler(),
    onMouseLeave: () => onMouseLeaveHandler(),
  }

  if (canReadLeaves) {
    return (
      <Link to={url} {...commonAttr}>
        {row}
      </Link>
    )
  }

  return <div {...commonAttr}>{row}</div>
}

export default MonthEvent
